import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { HomePage } from "./pages/HomePage";
import { BlogPage } from "./pages/BlogPage";
import { ArticleDetailPage } from "./pages/ArticleDetailPage";
import { GettingStartedPage } from "./pages/GettingStartedPage";
import { EquipmentPage } from "./pages/EquipmentPage";
import { LegalPage } from "./pages/LegalPage";
import { LexiquePage } from "./pages/LexiquePage";
import { Toaster } from "./components/ui/sonner";
import { ScrollToTop } from "./components/ScrollToTop";
import { NotFound } from "./pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<ArticleDetailPage />} />
            <Route path="/getting-started" element={<GettingStartedPage />} />
            <Route path="/equipment" element={<EquipmentPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/lexique" element={<LexiquePage />} />
            {/* La route 404 : le '*' signifie "tout le reste" */}
          <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
